import { autoinject } from "aurelia-dependency-injection";
import { CustomerVesselRoutes } from "../../constants/vessels/customer-vessels.constants";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { AddCustomerVesselsRequest, AddCustomerVesselsResponse, ChangeCustomerVesselsRequest, ChangeCustomerVesselsResponse, DoesCustomerHaveAccessToVesselRequest } from "../../models/vessels/customer-vessel.models";
import { GetCustomerVesselsResponse, RemoveCustomerVesselsRequest, RemoveCustomerVesselsResponse } from "../../models/customers/customer-vessels.models";

@autoinject
export class CustomerVesselService {
    constructor(private requestClient: RequestClientService) {
    }

    public addCustomerVessels(addCustomerVesselRequest: AddCustomerVesselsRequest): Promise<AddCustomerVesselsResponse> {
        return this.requestClient.post(`${CustomerVesselRoutes.AddCustomerVessels}`, {}, addCustomerVesselRequest);
    }

    public changeCustomerVessels(changeCustomerVesselRequest: ChangeCustomerVesselsRequest): Promise<ChangeCustomerVesselsResponse> {
        return this.requestClient.post(`${CustomerVesselRoutes.ChangeCustomerVessels}`, {}, changeCustomerVesselRequest);
    }

    public doesCustomerHaveAccessToVessel(request: DoesCustomerHaveAccessToVesselRequest): Promise<boolean> {
        return this.requestClient.post(`${CustomerVesselRoutes.DoesCustomerHaveAccessToVessel}`, {}, request);
    }

    public getCustomerVessels(): Promise<GetCustomerVesselsResponse> {
        return this.requestClient.get<GetCustomerVesselsResponse>(CustomerVesselRoutes.GetCustomerVessels, {});
    }

    public removeCustomerVessels(request: RemoveCustomerVesselsRequest): Promise<RemoveCustomerVesselsResponse> {
        return this.requestClient.post<RemoveCustomerVesselsResponse>(CustomerVesselRoutes.RemoveCustomerVessels, {}, request);
    }
}